import Plyr from 'plyr';
// import callInitOnConsent from './../usercentrics/components/call-init-on-consent';

const playerOptions = {
  captions: { active: true, update: true, language: 'de' },
  youtube: { noCookie: true },
};

const mapProviderAttributeToServiceName: { [key: string]: string } = {
  youtube: 'YouTube Video',
  vimeo: 'Vimeo',
};

function createPlayer(videoEl: HTMLElement) {
  const playerEl = videoEl.querySelector('.plyr__video-embed') as HTMLIFrameElement;
  if (videoEl.getAttribute('player-init') === 'true' || !playerEl) {
    return;
  }
  videoEl.setAttribute('player-init', 'true')

  const onPlayerError = () => {
    videoEl.classList.add('player-error');
  };
  
  const player = new Plyr(playerEl, playerOptions);

  player.on('error', onPlayerError);
}

export function init() {
  console.log('[loaded] video');

  const videoElements = document.querySelectorAll(
    '.video',
  ) as NodeListOf<HTMLElement>;

  videoElements.forEach((element) => {
    const provider = element.dataset.provider as string;
    const providerKey = mapProviderAttributeToServiceName[provider];
    createPlayer(element)
    // callInitOnConsent(window, providerKey, () => createPlayer(element))
  });
}
